module.exports = __webpack_public_path__ + "static/media/om_eyeshape_monolid_brown.c98cfd59.png";